import axios from "axios";

export const cdnApiAxios = axios.create({
  baseURL: process.env.VUE_APP_CDN_API_URL,
});
